export const pkg = require("../../package.json");
export const cliVersion = pkg.version;
